import React, { Component } from "react";
import { Card, CardHeader, CardBody, UncontrolledAlert } from "reactstrap";
import DataTable from "../../Shared/DataTable";
import { MdDone, MdClear, MdSearch } from "react-icons/md";

import Moment from "moment";
import { GoClock } from "react-icons/go";
import { ApprovedContents } from "../../../_constants/RouteVariables";
import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import { tourMessages } from "../../../_constants/tutorialmessages/ManualMessages";

const Approved = () => {
  return (
    <span style={{ color: "green" }}>
      <MdDone /> Approved
    </span>
  );
};
const Declined = () => {
  return (
    <span style={{ color: "red" }}>
      <MdClear /> Redraft
    </span>
  );
};

const Pending = () => {
  return (
    <span style={{ color: "#808080" }}>
      <GoClock /> Pending
    </span>
  );
};

export class AdminVerifiedContentTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: "all",
      run: false,
      stepIndex: 0,
      steps: [
        {
          target: tourMessages.adminContentsTables.target,
          content: (
            <div>
              <p>{tourMessages.adminContentsTables.content}</p>
            </div>
          ),
          placement: "left",
          locale: { skip: "SKIP", close: "Next" }
        },
        tourMessages.default
      ]
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.showNextJoyRide) {
      this.setState({ run: true });
      this.props.setNextJoyRide();
    }
  }

  changeValue = event => {
    this.setState({ status: event.target.value });

    this.props.filterData({
      status: event.target.value !== "all" ? event.target.value : ""
    });
  };

  handleJoyrideCallback = data => {
    const { action, index, status, type } = data;

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      this.setState({ stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) });
    } else if ([STATUS.CANCEL, STATUS.CANCEL].includes(status)) {
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      if ([STATUS.SKIPPED].includes(status)) {
        this.setState({ run: false });
      } else {
        this.props.routeChange();
      }
    }
  };

  render() {
    const columns = [
      {
        Header: "Interest",
        accessor: "interestName",
        maxWidth: 400,
        Filter: ({ filter, onChange }) => (
          <input
            onChange={event => onChange(event.target.value)}
            value={filter ? filter.value : ""}
            placeholder="&#x1F50D;"
            style={{
              width: "100%"
            }}
          />
        )
      },
      {
        Header: "Instructor",
        accessor: "instructorName"
      },
      {
        Header: "Title",
        accessor: "title",

        Filter: ({ filter, onChange }) => (
          <input
            onChange={event => onChange(event.target.value)}
            value={filter ? filter.value : ""}
            placeholder="&#x1F50D;"
            style={{
              width: "100%"
            }}
          />
        )
      },
      {
        Header: "Date",
        id: "submittedOn",
        accessor: d => {
          return Moment(d.submittedOn)
            .local()
            .format("DD-MM-YYYY ");
        },

        Filter: ({ filter, onChange }) => (
          <input
            onChange={event => onChange(event.target.value)}
            value={filter ? filter.value : ""}
            placeholder="&#x1F50D;"
            style={{
              width: "100%"
            }}
          />
        )
      },
      {
        Header: "Status",
        accessor: "status",

        id: "status",
        sortable: true,
        filterable: true,
        Cell: row => (
          <span>
            {row.value === "APPROVED" ? (
              <Approved />
            ) : row.value === "PENDING" ? (
              <Pending />
            ) : (
              <Declined />
            )}
          </span>
        ),

        Filter: filter => (
          <select
            onChange={this.changeValue}
            style={{ width: "60%" }}
            value={this.state.status}
          >
            <option value="all">Show All</option>
            <option value="APPROVED">Approved</option>
            <option value="DECLINED">Redraft</option>
            <option value="PENDING">Pending</option>
          </select>
        )
      },
      {
        Header: "Likes Count",
        accessor: "likesCount",

        id: "likesCount",
        sortable: true,

        Cell: row => (
          <span>
            {row.value > 0
              ? Number(row.value).toLocaleString("en-US")
              : "No likes yet"}
          </span>
        )
      }
    ];

    const {
      match,
      fetching,
      data,
      error,
      selectRow,
      pages,
      page,
      pageSize,
      setPageNumber,
      filterData,
      setPageSize
    } = this.props;
    const { run, steps, stepIndex } = this.state;
    const actions = [
      {
        name: "view",
        btnText: "View",
        isLink: true,
        type: "content",
        to: ApprovedContents,
        btnAction: selectRow,
        btnClass: "btn-success",
        btnIcon: MdSearch,
        tooltip: "View"
      }
    ];

    return (
      <div>
        <Joyride
          steps={steps}
          scrollToFirstStep
          showProgress
          showSkipButton
          styles={{
            options: {
              width: 200,
              height: 60,
              zIndex: 1000
            }
          }}
          callback={this.handleJoyrideCallback}
          run={run}
          stepIndex={stepIndex}
        />

        <Card>
          <CardHeader>Published Contents</CardHeader>
          <CardBody className="joyride3">
            {error && (
              <UncontrolledAlert color="danger">
                {error.message}
              </UncontrolledAlert>
            )}

            <DataTable
              columns={columns}
              loading={fetching}
              urlParams={match}
              data={data ? data.content : []}
              count={data ? data.count : 0}
              defaultPageSize={5}
              selectRow={selectRow}
              manual={true}
              pages={pages}
              page={page}
              pageSize={pageSize}
              showInstructorActions={false}
              filterData={filterData}
              setPageNumber={setPageNumber}
              setPageSize={setPageSize}
              searchParam="searchKey"
              searchPlaceholder="Search by title/instructor"
              actions={actions}
            />
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default AdminVerifiedContentTable;
